import GCAView from "src/components/feature/GCAView";

const GCAViewPage = () => {
  return <GCAView />;
};

export default GCAViewPage;
